if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewerContainer: this.querySelector('[id^="GalleryVwContainer"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          previousBtn:   this.querySelector('button[name="previous"]'),
          nextBtn: this.querySelector('button[name="next"]'),
          slider: this.querySelector('[id^="Slider-Thumbnails"]'),
          sliderItems: this.querySelectorAll('[id^="Slide-"]')
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.viewer2 = this.elements.viewerContainer,
        this.currentIndex = 0;
        this.sliderItemsToShow = Array.from(this.elements.sliderItems).filter(
          (element) => element.clientWidth > 0,
        )
        this.numberOfSliderItems = this.sliderItemsToShow.length;
        if (this.numberOfSliderItems  < 2) return;
        this.sliderItemOffset =
          this.sliderItemsToShow[5]?.offsetLeft -
          this.sliderItemsToShow[0].offsetLeft;
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500),
        );
        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false,
                ),
              );
          });
        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        )
          this.removeListSemantic();
          this.elements.previousBtn.addEventListener('click', this.onCarouselBtnClick.bind(this));
          this.elements.nextBtn.addEventListener('click', this.onCarouselBtnClick.bind(this));
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`,
            );
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img',
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position,
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
        const iframe = deferredMedia?.querySelector('iframe');
        if (iframe) {
          let src = new URL(iframe.src);
          src.searchParams.set("origin", "https://shop.cyklop.com");
          iframe.src = src.toString();
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation'),
        );
      }

      onCarouselBtnClick(event) {
        event.preventDefault();
        this.counter = this.elements.viewer
        .querySelectorAll('[id^="Slider-Gallery-template"] > li').length;

        if (event.currentTarget.name === 'previous') {
          this.newIndex = this.currentIndex > 0 ? (this.currentIndex - 1) % this.counter : this.counter - 1;
          this.scrollThroughGallery(this.newIndex)
        } else {
          this.newIndex = (this.currentIndex + 1) % this.counter
          this.scrollThroughGallery(this.newIndex)
        }
          this.slideScrollPosition = event.currentTarget.name === 'next'
            ? this.elements.slider.scrollLeft + this.currentIndex * this.sliderItemOffset
            : this.elements.slider.scrollLeft - (this.currentIndex) * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
      }

      scrollThroughGallery(elementIndex) {
        this.currentIndex = elementIndex
        const activeMedia = this.elements.viewer
        .querySelectorAll('[id^="Slider-Gallery-template"] > li')[elementIndex];
        this.elements.viewer
          .querySelectorAll('[id^="Slider-Gallery-template"] > li')
          .forEach((element) => {
            element.classList.remove('is-active');
          });
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        activeMedia.classList.add('is-active');
          this.playActiveMedia(activeMedia);
        this.elements.thumbnails
          .querySelectorAll('button')[elementIndex].setAttribute('aria-current', true);
      }

      setSlidePosition(position) {
        this.elements.slider.scrollTo({
          left: position,
          behavior: 'smooth',
        });
      }
    },
  );
}
